/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from './useFormUtils'

const Comments = ({ item, isDisabled }) => {
  const [packaging] = useState({
    Comments: item?.Comments,
  })
  const methods = useFormContext()
  const { onChangeReviewer } = useFormUtils()

  return (
    <Row>
      <Col xs={12}>
        <FormGroup>
          <p>
            <strong>Reason/Comment</strong>
          </p>
          <Controller
            as={<Input type="textarea" />}
            name="Comments"
            defaultValue={packaging.Comments || ''}
            control={methods.control}
            rules={{
              maxLength: {
                value: 500,
                message: '⚠ Comment exceeds 500 characters.',
              },
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Comments"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default Comments
